import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { OpeningLead } from '../components/OpeningLead';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel and fire PageView on load
  useMetaPixel();
  // Set page title
  useEffect(() => {
    document.title = 'USA Sin Caos - Rutina Anti Estrés';
  }, []);
  return <div className="min-h-screen bg-[#FDF8F3] font-sans selection:bg-[#C75B3F]/20 selection:text-[#C75B3F]" data-id="element-207">
      <main data-id="element-208">
        <Hero data-id="element-209" />
        <OpeningLead data-id="element-210" />
        <ProblemSection data-id="element-211" />
        <SolutionSection data-id="element-212" />
        <IncludesSection data-id="element-213" />
        <WhoIsItFor data-id="element-214" />
        <PricingSection data-id="element-215" />
      </main>
      <Footer data-id="element-216" />
    </div>;
}